<template>
  <div>
    <div class="preloader" style="display: flex;flex-direction: column;">
      <img src="/assets/images/logo.svg">
      <h2 class="text-white">Integrated Platform</h2>

      <div class="sk-double-bounce">
        <div class="sk-child sk-double-bounce1"></div>
        <div class="sk-child sk-double-bounce2"></div>
      </div>
    </div>

    <div class="mdk-header-layout js-mdk-header-layout">
      <!-- Header -->

      <div
        id="header"
        class="mdk-header bg-dark js-mdk-header mb-0"
        data-effects="waterfall blend-background"
        data-fixed
        data-condenses
      >
        <div class="mdk-header__content">
          <div data-primary class="navbar navbar-expand-sm navbar-dark bg-dark p-0" id="navbar">
            <div class="container">
              <!-- Navbar Brand -->
              <a href="/" class="navbar-brand">
                <img
                  class="navbar-brand-icon"
                  src="/assets/images/logo/white-100.svg"
                  width="100"
                  alt="N-Power"
                >
                <span class="d-none d-md-block"></span>
              </a>

              <!-- Main Navigation -->
              <ul
                class="nav navbar-nav ml-auto flex-nowrap"
                style="white-space: nowrap; border-bottom: none"
              >
                <template v-if="isLoggedIn">
                  <li class="ml-16pt nav-item">
                    <router-link active-class="nav-link" :to="{name: 'logout'}" exact>
                      <i class="material-icons">lock</i>
                      Logout
                    </router-link>
                  </li>

                  <li class="d-none d-sm-flex nav-item">
                    <router-link :to="{ name: 'dashboard'}" class="btn btn-accent" exact>Dashboard</router-link>
                  </li>
                </template>
                <template v-else>
                  <li class="ml-16pt nav-item">
                    <router-link active-class="active" :to="{path: '/login'}" exact>
                      <i class="material-icons">lock_open</i>
                      Login
                    </router-link>
                  </li>
                </template>
              </ul>

              <!-- // END Main Navigation -->

              <!-- Navbar toggler -->
              <button
                class="navbar-toggler navbar-toggler-right d-block d-md-none"
                type="button"
                data-toggle="sidebar"
                @click="drawerShow =!drawerShow"
              >
                <span class="navbar-toggler-icon"></span>
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- // END Header -->

      <!-- Header Layout Content -->
      <div class="mdk-header-layout__content page-content pb-0">
        <div class="navbar navbar-expand-sm navbar-mini navbar-dark bg-dark d-none d-sm-flex p-0">
          <div class="container">
            <!-- Main Navigation -->
            <ul class="nav navbar-nav flex-nowrap">
              <li class="nav-item">
                <a class="nav-link nolink">Hardware</a>
              </li>
              <li class="nav-item">
                <a href="#" class="nav-link nolink">Software</a>
              </li>
              <li class="nav-item">
                <a href="#" class="nav-link nolink">Creatives</a>
              </li>
            </ul>
            <!-- // END Main Navigation -->
          </div>
        </div>
      </div>
    </div>

    <!-- drawer -->
    <div
      class="mdk-drawer js-mdk-drawer"
      style="z-index: 10; "
      id="default-drawer"
      data-opened
      v-show="drawerShow"
    >
      <div class="mdk-drawer__content">
        <div class="sidebar sidebar-dark sidebar-left" data-perfect-scrollbar>
          <div class="sidebar-p-a sidebar-b-b sidebar-m-b pt-0">
            <!-- Brand -->
            <a href="/" class="sidebar-brand">
              <img
                class="sidebar-brand-icon"
                src="assets/images/logo/white-100.svg"
                width="30"
                alt="N-Power"
              >
              <span class="title">Integrated Platform</span>
            </a>
            <!-- // END Brand -->

            <!-- Search -->
          </div>

          <ul class="sidebar-menu">
            <li class="sidebar-menu-item active" @click="close">
              <router-link
                class="sidebar-menu-button"
                active-class="active"
                :to="{name: 'homepage'}"
              >Homepage</router-link>
            </li>
          </ul>

          <div class="sidebar-heading">Learning Paths</div>
          <ul class="sidebar-menu">
            <li class="sidebar-menu-item" @click="close">
              <router-link
                class="sidebar-menu-button"
                active-class="active"
                :to="{name: 'dashboard'}"
              >Dashboard</router-link>
            </li>

            <li class="sidebar-menu-item" @click="close">
              <router-link
                class="sidebar-menu-button"
                active-class="active"
                :to="{name: 'forum'}"
              >General forum</router-link>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- // END drawer -->
    <div
      class="navbar navbar-expand-sm navbar-mini navbar-dark bg-dark d-none d-sm-flex p-0"
      style="margin-top: 20px;"
    >
      <div class="container">
        <!-- Main Navigation -->
        <ul class="nav navbar-nav flex-nowrap">
          <li class="nav-item">
            <a href="#" class="nav-link nolink">Hardware</a>
          </li>
          <li class="nav-item">
            <a href="#" class="nav-link nolink">Software</a>
          </li>
          <li class="nav-item">
            <a href="#" class="nav-link nolink">Creatives</a>
          </li>
        </ul>
        <!-- // END Main Navigation -->
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "Header",
  computed: {
    ...mapGetters(["isLoggedIn", "userObject"])
  },
  data() {
    return {
      drawerShow: false,
      id: this.$session.get("id"),
      category: this.$session.get("category")
    };
  },
  methods: {
    close() {
      this.drawerShow = false;
    }
  },
  mounted() {
    $(".preloader").fadeOut();
  }
};
</script>

<style lang="scss" scoped>
.nolink {
  margin-top: 5px;
  cursor: default;
}

.btn {
  &__group {
    margin-left: 10px;
    display: flex;
    align-items: center;
  }
  &__sm {
    font-size: 14px;
    height: 40px;
  }
}

.nav__trigger {
  span {
    pointer-events: none;
  }
}

.sub-title {
  width: 90%;
  line-height: 1.4;
}
</style>
